import {h, Fragment} from "preact"
import { useEffect, useState } from "preact/hooks"

export default function SortSelect({ id, activeSort, onChange, className, options, preSelectedOption }) {
    /* merchant requested text "Sort" appears before selecting a sort option */
    const [ manualSort, setManualSort ] = useState(false);

    useEffect(() => {
        setManualSort(location.href.includes('sort='))
    }, [ location.href ])

    return (
        <select
            id={id}
            className={`${className}`}
            value={!manualSort ? null : activeSort}
            onChange={onChange}
        >
            {(preSelectedOption) && 
                <option 
                    value="" 
                    disabled 
                    selected={!manualSort}
                >
                    {preSelectedOption}
                </option>
            }
            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    )
}